import { render } from "./ResidentInsurance.vue?vue&type=template&id=65ec665e"
import script from "./ResidentInsurance.vue?vue&type=script&lang=js"
export * from "./ResidentInsurance.vue?vue&type=script&lang=js"

import "./ResidentInsurance.vue?vue&type=style&index=0&id=65ec665e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__